import { render, staticRenderFns } from "./PackPopup.vue?vue&type=template&id=07b2be10&scoped=true&"
import script from "./PackPopup.vue?vue&type=script&lang=ts&"
export * from "./PackPopup.vue?vue&type=script&lang=ts&"
import style0 from "./PackPopup.vue?vue&type=style&index=0&id=07b2be10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b2be10",
  null
  
)

export default component.exports